window.Products.DeviceCase.IphoneX = function() {
};
window.Products.DeviceCase.IphoneX.inherits(window.Products.DeviceCase.DeviceCase);

window.Products.DeviceCase.IphoneX.id = 72;
window.Products.DeviceCase.IphoneX.slug = 'iphonex';
window.Products.DeviceCase.IphoneX.has_3d = true;
window.Products.DeviceCase.IphoneX.dpi = 300;

window.Products.DeviceCase.IphoneX.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.66;
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.IphoneX.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.1;
	controls.maxDistance = 4.1;
};

window.Products.DeviceCase.IphoneX.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[0].map = modelViewer.texture;
};